module.exports = __webpack_public_path__ + "static/media/hanoi_thumb_even.d25209cf.jpg";